/**
 * This enum handle base SmartComponent type for UI render
 */
export enum SmartComponentType {
  UNKNOWN = 0,
  ELECTRIC = 1,
  HOT_WATER = 2,
  COLD_WATER = 3,
  HEATING = 4,
  DISTRIBUTOR = 5,
  GAS = 6,
  BLINDS = 7,
  LIGHT = 8,
  DIMMER = 9,
  CONTACT = 10,
  ALARM = 11,
  THERMOSTAT = 12,
  SENSOR = 13,
  WEATHER_STATION = 14,
  LABEL = 15,
  PAGE_BREAK = 16,
  SCENARIO = 17
}

/**
 * Counter (meter) smart-component kinds, as opposed to domotic objects.
 * Single source of truth for splitting components into the "counters" and
 * "domotic components" sections of the supervision detail page.
 */
const COUNTER_SMART_COMPONENT_TYPES: ReadonlyArray<SmartComponentType> = [
  SmartComponentType.ELECTRIC,
  SmartComponentType.HOT_WATER,
  SmartComponentType.COLD_WATER,
  SmartComponentType.HEATING,
  SmartComponentType.DISTRIBUTOR,
  SmartComponentType.GAS,
];

/**
 * Tells whether a smart-component kind is a counter (meter) rather than a
 * domotic object (light, dimmer, thermostat, …).
 *
 * @param kind smart-component kind to classify
 * @returns `true` when the kind is a counter/meter, `false` otherwise
 */
export function isSmartComponentCounterType(kind: SmartComponentType): boolean {
  return COUNTER_SMART_COMPONENT_TYPES.includes(kind);
}
